import { FollowButton } from './FollowButton'
import { withFollowButton } from './withFollowButton'

const ConnectedFollowButton = withFollowButton(FollowButton)
export { ConnectedFollowButton as FollowButton }
